import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/image/icon/icon_hint@2x.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "icon"
  }),
  /*#__PURE__*/_createElementVNode("h3", null, "ご注意ください")
], -1)
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "footer" }

import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useRtfix } from '@/store'
import { t } from '@/plugins/i18n'
import { useStore } from 'vuex'
import { passwordChangeFlag, updatePasswordChange } from '@/apis/login'
import { memberChangeFlag } from '@/apis/membership'


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const router = useRouter()
const store = useStore()
const dialogVisible = ref(false)
const membership = store.getters.membership
// 获取是否修改密码状态，建议用户修改密码
const getPasswordChange = () => {
  passwordChangeFlag().then((res: any) => {
    if (!res.data) dialogVisible.value = true
  })
}
// 更新是否修改密码弹窗
const updatePwdChange = () => {
  updatePasswordChange().then((res: any) => {
    if (res.code === '0') {
      dialogVisible.value = false
    }
  })
}
//
const openModal = () => {
  getPasswordChange()
}

const closeModal = () => {
  // 更新修改密码状态
  updatePwdChange()
}

//  去修改密码
const linkToPwd = () => {
  updatePwdChange()
  router.push(useRtfix('setupUser', { query: { type: 'SetupPwd' } }))
}

expose({
  openModal
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      "model-value": dialogVisible.value,
      width: "460px",
      "custom-class": "pwdSecurity",
      onClose: closeModal,
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('系统检测到您当前的密码过于简单，存在安全风险，建议您修改密码。')), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: linkToPwd
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("修改密码")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}
}

})